import { render, staticRenderFns } from "./shoppingModel.vue?vue&type=template&id=a665b8da&scoped=true&"
import script from "./shoppingModel.vue?vue&type=script&lang=js&"
export * from "./shoppingModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665b8da",
  null
  
)

export default component.exports